/* exported mapCallbacks */
var mapCallbacks = {};

(function () {
    'use strict';
    angular.module('defaults', [])
        .value('serviceBase', '/eis-services');

    angular.module('core', ['defaults', 'ngCookies', 'ngDialog']);
    angular.module('map', []);
    angular.module('table', []);
    angular.module('filter', []);
    angular.module('edit', ['isteven-multi-select']);
    angular.module('gallery', []);
    angular.module('document', []);
    angular.module('notes', ['ngSanitize']);
    angular.module('validation', []);
    angular.module('roadMeasurements', []);

    var app = angular.module('roadMonitoringObjApp', [
        // libs
        'ngRoute', 'mobile-angular-ui', 'mobile-angular-ui.core.outerClick', 'angucomplete-alt', 'pickadate', 'ngFileUpload',
        'ui.bootstrap.datepickerPopup', 'uib/template/datepicker/datepicker.html', 'uib/template/datepicker/day.html', 'uib/template/datepicker/month.html', 'uib/template/datepicker/year.html', 'uib/template/datepickerPopup/popup.html',
        'ui.bootstrap.timepicker', 'uib/template/timepicker/timepicker.html',
        // app
        'defaults', 'core', 'table', 'map', 'filter', 'edit', 'notes', 'gallery', 'document', 'validation', 'roadMeasurements'
    ]);

    app.config(function ($routeProvider, pickadateI18nProvider) {
        $routeProvider.when('/map', { templateUrl: 'layout/map.html', controller: 'MapController', reloadOnSearch: false });
        $routeProvider.when('/table', { templateUrl: 'layout/table.html', controller: 'TableController', reloadOnSearch: false });
        $routeProvider.when('/login', { templateUrl: 'layout/login.html', controller: 'LoginController', reloadOnSearch: false });
        $routeProvider.when('/table/:id', { templateUrl: 'layout/table.html', controller: 'TableController', reloadOnSearch: false, resolve: {
            validateId: function($route, $location) {
                var id = $route.current.params.id;
                if (!/^\d+$/.test(id)) {
                    $location.path('/map');
                }
            }
        }});
        $routeProvider.otherwise('/map');

        pickadateI18nProvider.translations = {
            prev: 'Buvęs',
            next: 'Kitas'
        };

    });

    app.config(function ($httpProvider) {
        $httpProvider.interceptors.push(function (keycloakService, serviceBase) {
            return {
                'request': function (config) {
                    if (config.url.startsWith(serviceBase)) {
                        config.headers.Authorization = 'Bearer ' + keycloakService.getAccessToken();
                    }
                    return config;
                }

            };
        });
    });

    app.config(function(uibDatepickerPopupConfig) {
        uibDatepickerPopupConfig.clearText = 'Išvalyti';
        uibDatepickerPopupConfig.closeText = 'Uždaryti';
        uibDatepickerPopupConfig.currentText = 'Šiandien';
    });

    app.run(function($rootScope, $location, userService, dataConfigService, $window) {
        if ($location.path().indexOf('/login') === -1) {
            var path = $location.path();
            userService.login((path == '' || path.startsWith('/map')) ? null : path).then(function() {
                if (!userService.getPermissions().view) {
                    userService.logout('/login?info=no-rights')
                }
                dataConfigService.setShownColumns();
                $rootScope.$apply();
            })
        }

        angular.element($window).bind('resize', function () {
            dataConfigService.setShownColumns();
            $rootScope.$apply();
        });

    });

})();
